import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e818f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`modal z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center`)
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" }, null, -1))
const _hoisted_3 = { class: "container-modal z-50 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-white fill-current",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "(Esc)", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "titleBold" }, "Duplicar política", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-black fill-current",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "grid md:grid-cols-1 grid-cols-1 gap-4 my-4" }
const _hoisted_11 = { class: "flex justify-end" }

import { reactive, ref, watch } from 'vue'

import Input from '@/components/designSystem/Inputs/Input.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'

import { mdiPlus } from '@mdi/js'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { DsPolicyItem } from '@/Network/Types/Responses/DsPolicyResponses'
import { useEscapeKey } from '@/utils/DOMEvents'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modalActive: { type: Boolean },
    policy: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const toast = useToast()
const { notifyError } = useErrorToast()
const dsPolicyStore = useDsPolicyStore()

const { listCompanies } = storeToRefs(useCompanyStore())
const { isLoading } = storeToRefs(dsPolicyStore)



const keyRender = ref(Math.random())

useEscapeKey(() => {
  close()
})

const error = reactive({
  name: false,
  companyId: false
})

const form = reactive({
  name: '',
  companyId: ''
})

const isValid = ref(Object.values(error).every((e) => e != true))

watch(form, () => {
  isValid.value = Object.values(error).every((e) => e != true)
})

function validateUserName() {
  error.name = form.name.trim() === ''
}

function validateCompanyId() {
  error.companyId = !form.companyId
}

function validateAll() {
  validateUserName()
  validateCompanyId()

  isValid.value = Object.values(error).every((e) => e != true)
}

const duplicateDsPolicy = async () => {
  validateAll()
  if (!isValid.value || !props.policy) return

  try {
    const dsPolicy = await dsPolicyStore.duplicateDsPolicy(props.policy.id, {
      newPolicyName: form.name.trim(),
      targetCompanyId: Number(form.companyId)
    })

    if (dsPolicy?.id) {
      await dsPolicyStore.fetchDsPolicyById(dsPolicy.id)
      close()
      toast.success('Política duplicada com sucesso!')
    }
  } catch (e) {
    notifyError(e, 'Não foi possível duplicar a política de restrição.')
  }
}

const close = async () => {
  Object.keys(form).forEach((key) => {
    form[key] = ''
  })

  Object.keys(error).forEach((key) => {
    error[key] = false
  })

  keyRender.value = Math.random()

  emits('close')
}



return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: close,
          class: "absolute md:inline flex top-0 right-0 z-50 flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close"
        }, _hoisted_6),
        (_openBlock(), _createElementBlock("div", {
          class: "px-6 py-4 text-left modal-content",
          key: keyRender.value
        }, [
          _createElementVNode("div", { class: "flex items-center justify-between pb-3" }, [
            _hoisted_7,
            _createElementVNode("div", {
              class: "z-50 cursor-pointer modal-close",
              onClick: close
            }, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Input, {
              isError: error.name,
              onChange: _cache[0] || (_cache[0] = () => validateUserName()),
              errorMessage: "Nome da política inválido",
              width: "100%",
              label: "Nome da política",
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
              required: ""
            }, null, 8, ["isError", "modelValue"]),
            _createVNode(_component_v_autocomplete, {
              modelValue: form.companyId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.companyId) = $event)),
              color: "primary20",
              label: "Empresa",
              items: _unref(listCompanies),
              variant: "outlined"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(OutlineButton, {
              onClick: close,
              class: "mr-4",
              text: "Cancelar",
              width: "120px"
            }),
            _createVNode(FilledButton, {
              loading: _unref(isLoading),
              text: "Criar",
              width: "100px",
              onClick: duplicateDsPolicy,
              "prepend-icon": _unref(mdiPlus)
            }, null, 8, ["loading", "prepend-icon"])
          ])
        ]))
      ])
    ], 512), [
      [_vShow, _ctx.modalActive]
    ])
  ]))
}
}

})